export default __webpack_public_path__ + "static/media/974.f2455404.png";